import React, { Component } from 'react';
import '../../Modal.css';
import { connect } from 'react-redux';
import { updateSelectedPartner } from '../../../../actions/adminActions/partnersActions';
import { partners } from '../../../../apis/backend';

class EditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      name: ''
    };
  }

  clearState() {
    this.setState({
      id: '',
      name: ''
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.selectedPartner !== this.props.selectedPartner &&
      this.props.selectedPartner !== 0
    ) {
      const partner = this.props.partners.find((obj) => obj.id === this.props.selectedPartner);
      if (partner) {
        this.setState({
          name: partner.name
        });
      }
    }
  }

  async partnerRequest() {
    try {
      await partners
        .patch(
          `/${this.props.selectedPartner}`,
          {
            name: this.state.name
          },
          { headers: { authorization: this.props.employeeToken } }
        )
        .then(this.clearState())
        .catch((response) => {
          console.log(response);
          alert('Sorry, an error occurred. Please check your entries.');
        });
    } catch (err) {
      console.log('Request Failed.');
    }
  }

  render() {
    return (
      <div id="exampleModal" className="modal fade" style={{ overflow: 'scroll' }}>
        <div className="modal-dialog modal-dialog-centered lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Partner</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="input-group input-group-sm mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    Partner Name
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  value={this.state.name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => this.clearState()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-dark"
                data-dismiss="modal"
                onClick={() => {
                  this.partnerRequest();
                }}
                disabled={!this.state.name != ''}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  partners: state.admin.admin.partners,
  selectedPartner: state.admin.partners.selectedPartner,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, { updateSelectedPartner })(EditModal);
